import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import Button from "../../../../../../../../components/ui/Button";
import Text from "../../../../../../../../components/ui/Text";

export const StripeConnectDialog = ({ open, onClose }) => {
  const [stripeConnecting, setStripeConnecting] = useState(false);

  // Generate Stripe OAuth URL with error handling
  const getStripeOAuthUrl = () => {
    const clientId = process.env.REACT_APP_STRIPE_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_STRIPE_REDIRECT_URI;

    if (!clientId || !redirectUri) {
      return "#"; // Return a placeholder URL to prevent errors
    }

    return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${clientId}&scope=read_write&redirect_uri=${redirectUri}`;
  };

  const handleClose = () => {
    setStripeConnecting(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { borderRadius: "12px", m: 2, width: "310px" } },
      }}
    >
      <DialogTitle sx={{ p: 2 }}>
        <Text variant="pageHeader" sx={{ fontSize: "20px" }}>
          {stripeConnecting
            ? "Please complete your Stripe account setup"
            : "Get ready to collect payments"}
        </Text>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        {stripeConnecting ? (
          <>
            <Text
              variant="paragraph"
              component="p"
              sx={{ fontSize: "16px", lineHeight: 1.5 }}
            >
              This window will close automatically once your account is active.
            </Text>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <CircularProgress size={40} sx={{ color: "#000", mx: "auto" }} />
            </Box>
          </>
        ) : (
          <>
            <Text
              variant="paragraph"
              component="p"
              sx={{ fontSize: "16px", lineHeight: 1.5 }}
            >
              To start receiving payments from players, connect your Stripe
              account.
            </Text>
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Box
                sx={{
                  borderRadius: "50%",
                  width: "6px",
                  height: "6px",
                  backgroundColor: "#000",
                }}
              />
              <Text variant="paragraph" sx={{ ml: 1 }}>
                Instant payouts after games
              </Text>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  borderRadius: "50%",
                  width: "6px",
                  height: "6px",
                  backgroundColor: "#000",
                }}
              />
              <Text variant="paragraph" sx={{ ml: 1 }}>
                Safe & compliant with Stripe
              </Text>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  borderRadius: "50%",
                  width: "6px",
                  height: "6px",
                  backgroundColor: "#000",
                }}
              />
              <Text variant="paragraph" sx={{ ml: 1 }}>
                Takes just 2-3 minutes
              </Text>
            </Box>
          </>
        )}
      </DialogContent>
      <Box
        sx={{
          p: 2,
          pt: 1,
          gap: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {!stripeConnecting && (
          <>
            <Button
              component="a"
              href={getStripeOAuthUrl()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={setStripeConnecting}
              variant="primary"
              sx={{ width: "auto" }}
            >
              Connect Stripe account
            </Button>
            <Button
              component="a"
              href="https://slow-centipede-6ab.notion.site/How-payments-work-on-Findaside-2843273d40638042b99fd11353831436"
              target="_blank"
              rel="noopener noreferrer"
              variant="secondary"
              sx={{ width: "auto" }}
            >
              Learn more
            </Button>
          </>
        )}
        <Button variant="tertiary" onClick={handleClose} sx={{ width: "auto" }}>
          Cancel
        </Button>
        <Text
          component="p"
          sx={{ color: "#A1A1A1", fontSize: "14px", textAlign: "center" }}
          variant="paragraph3"
        >
          Powered by Stripe
        </Text>
      </Box>
    </Dialog>
  );
};
